// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__xSI0_","fileBtn":"File_fileBtn__30wFq","closeBtn":"File_closeBtn__1OKyt","fileSelected":"File_fileSelected__19TKX","disabled":"File_disabled__1ys-k"};